import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import { mapDtoToWebCams, type WebCamsType } from "../model";

export const getCurrentWebCams = async (
  camsType: string,
  pageCount: number,
) => {
  const filters =
    camsType !== "all"
      ? {
          web_cams_types: {
            uid: {
              $in: [camsType],
            },
          },
        }
      : {};

  const searchParams = {
    pagination: {
      page: pageCount || 1,
      pageSize: 4,
    },
    filters: { ...filters },
    populate: {
      web_cams_types: {
        populate: "*",
      },
      cameraPosition: {
        populate: "*",
      },
      previewImage: {
        populate: "*",
      },
      cameraDetail: {
        populate: "*",
      },
    },
  };

  const webCamsData = strapiClient.collection("web-cams");

  const webCams = await webCamsData.find({
    ...searchParams,
  });

  return rebuild(mapDtoToWebCams(webCams)) as WebCamsType;
};
